import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenField", "selectedName", "menu", "option"]

  selectContractor(event) {
    event.preventDefault()
    const contractorId = event.currentTarget.dataset.contractorId
    const contractorName = event.currentTarget.dataset.contractorName

    this.hiddenFieldTarget.value = contractorId
    this.selectedNameTarget.textContent = contractorName

    this.optionTargets.forEach((option) => {
      const dot = option.querySelector('.indicator-dot')
      const isSelected = option.dataset.contractorId === contractorId

      if (isSelected) {
        option.classList.remove('bg-white', 'hover:bg-gray-50')
        option.classList.add('bg-[#d4e8e8]', 'hover:bg-[#d4e8e8]')
        dot.classList.remove('invisible')
      } else {
        option.classList.remove('bg-[#d4e8e8]', 'hover:bg-[#d4e8e8]')
        option.classList.add('bg-white', 'hover:bg-gray-50')
        dot.classList.add('invisible')
      }
    })

    this.menuTarget.classList.add("hidden")
  }

  toggleMenu(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")
  }

  hideMenu(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
    }
  }
}
